<template>
  <div>
    <div class="row">
      <div class="bs-callout bs-callout-maker-teams bs-callout-title">
        <div class="bs-callout-title-box">
          <h2>Currently we are hosting these Mario Maker Teams!</h2>
        </div>
      </div>
      <div class="bs-callout bs-callout-maker-teams bs-callout-content">
        <div class="col-md-4 col-sm-6 p-1">
          <div class="card team-card teamshell-primary-bc">
            <img src="/assets/teams/teamshell/logo.png" class="card-img-top card-img-team-logo" alt="logo">
            <div class="card-body">
              <h2 class="card-title"><router-link to="/teamshell"><span class="teamshell-primary-fg">#Team</span><span class="teamshell-secondary-fg">Shell</span></router-link></h2>
              <p class="card-text">
                TeamShell is one of the biggest teams around and centered all around one thing: tough shell kaizo levels.
              </p>
              <p class="card-text">
                If you're looking for levels with shelljumps this is the team for you!
              </p>
              <router-link to="/teamshell" class="btn teamshell-primary-bg team-card-nav-button" style="color:white;">Go check it out!</router-link>
            </div>
          </div>
        </div>
        <div class="col-md-4 col-sm-6 p-1">
          <div class="card team-card teamjamp-primary-bc">
            <img src="/assets/teams/teamjamp/logo.png" class="card-img-top card-img-team-logo card-img-rounded-logo" alt="logo">
            <div class="card-body">
              <h2 class="card-title"><router-link to="/teamjamp"><span class="teamjamp-primary-fg">Team</span><span class="teamjamp-secondary-fg"> Jamp</span></router-link></h2>
              <p class="card-text">
                TeamJamp is a relatively new team centered all around platforming.
              </p>
              <p class="card-text">
                If you want a more traditional platforming kaizo experience without tons of tough tech, you're gonna love this team!
              </p>
              <router-link to="/teamjamp" class="btn teamjamp-primary-bg team-card-nav-button" style="color:white;">Go check it out!</router-link>
            </div>
          </div>
        </div>
        <div class="col-md-4 col-sm-6 p-1">
          <div class="card team-card teamprecision-primary-bc">
            <img src="/assets/teams/teamprecision/logo.png" class="card-img-top card-img-team-logo card-img-rounded-logo" alt="logo">
            <div class="card-body">
              <h2 class="card-title"><router-link to="/teamprecision"><span class="teamprecision-primary-fg">#Team</span><span class="teamprecision-secondary-fg">Precision</span></router-link></h2>
              <p class="card-text">
                #TeamPrecision is a group of players who like to play the precision genre of Mario Maker.
              </p>
              <p class="card-text">
                Precision levels are usually short levels consisting of a series of fairly tight jumps between sprites or spikes. If that sounds like your type of level give them a look.
              </p>
              <router-link to="/teamprecision" class="btn teamprecision-primary-bg team-card-nav-button" style="color:white;">Go check it out!</router-link>
            </div>
          </div>
        </div>
        <div class="col-md-4 col-sm-6 p-1">
          <div class="card team-card teampipe-primary-bc">
            <img src="/assets/teams/teampipe/logo.png" class="card-img-top card-img-team-logo card-img-rounded-logo" alt="logo">
            <div class="card-body">
              <h2 class="card-title"><router-link to="/teampipe"><span class="teampipe-primary-fg">#Team</span><span class="teampipe-secondary-fg">Pipe</span></router-link></h2>
              <p class="card-text">
                TeamPipe is a group of kaizo makers who are all about making hard levels with pipe aesthetics.
              </p>
              <p class="card-text">
                If you're looking to challenge yourself and join the ranks of some expert players, then this is the team for you!
              </p>
              <router-link to="/teampipe" class="btn teampipe-primary-bg team-card-nav-button" style="color:white;">Go check it out!</router-link>
            </div>
          </div>
        </div>
        <div class="col-md-4 col-sm-6 p-1">
          <div class="card team-card teamflight-primary-bc">
            <img src="/assets/teams/teamflight/logo.png" class="card-img-top card-img-team-logo card-img-rounded-logo" alt="logo">
            <div class="card-body">
              <h2 class="card-title"><router-link to="/teamflight"><span class="teamflight-primary-fg">Team</span><span class="teamflight-secondary-fg"> Flight</span></router-link></h2>
              <p class="card-text">
                Team Flight is one of the oldest teams around. No matter if you prefer cape, tanooki, propeller, acorn or whatever else that can take to the skies, they got something for you.
              </p>
              <p class="card-text">If you want to fly away to victory, then this is where you can spread your wings.</p>
              <router-link to="/teamflight" class="btn teamflight-primary-bg team-card-nav-button" style="color:white;">Go check it out!</router-link>
            </div>
          </div>
        </div>
        <div class="col-md-4 col-sm-6 p-1">
          <div class="card team-card teamzeropercent-primary-bc">
            <img src="/assets/teams/teamzeropercent/logo.png" class="card-img-top card-img-team-logo" alt="logo">
            <div class="card-body">
              <h2 class="card-title"><span class="teamzeropercent-primary-fg">Team</span>&nbsp;<span class="teamzeropercent-secondary-fg">0%</span></h2>
              <p class="card-text">
                Team 0% is a group dedicated to making sure that every single level in both Super Mario Maker and Super Mario Maker 2 has at least one clear on it, hence the name 0% for the 0% level clear-rates. They're the second-largest SMM team and we are constantly growing in size!  If you want to grind out some first clears, or just hang out and find some hot garbage levels to play, then come on in!
              </p>
              <a href="https://discord.gg/hpQJdYAXWE" target="_blank" class="btn teamzeropercent-primary-bg team-card-nav-button" style="color:white;">Join the discord!</a>
            </div>
          </div>
        </div>
        <div class="col-md-4 col-sm-6 p-1">
          <div class="card team-card teamicicle-primary-bc">
            <img src="/assets/teams/teamicicle/logo.png" class="card-img-top card-img-team-logo" alt="logo">
            <div class="card-body">
              <h2 class="card-title"><router-link to="/teamicicle"><span class="teamicicle-primary-fg">Team</span><span class="teamicicle-secondary-fg">Icicle</span></router-link></h2>
              <p class="card-text">
                TeamIcicle is a group of icicle fanatics who enjoy all things icicle!
              </p>
              <p class="card-text">
                If icicles are the focal point in your levels, join TeamIcicle today and share YOUR icetastic levels!
              </p>
              <router-link to="/teamicicle" class="btn teamicicle-primary-bg team-card-nav-button" style="color:white;">Go check it out!</router-link>
            </div>
          </div>
        </div>
        <div class="col-md-4 col-sm-6 p-1">
          <div class="card team-card teampswitch-primary-bc">
            <img src="/assets/teams/teampswitch/logo.png" class="card-img-top card-img-team-logo" alt="logo">
            <div class="card-body">
              <h2 class="card-title"><router-link to="/teampswitch"><span class="teampswitch-primary-fg">Team</span><span class="teampswitch-secondary-fg"> P-Switch</span></router-link></h2>
              <p class="card-text">
                Team P-Switch is all about P-Switches and everything around them.
              </p>
              <p class="card-text">
                If you're a fan of these items and any of their associated mechanics, this is the place for you.
              </p>
              <router-link to="/teampswitch" class="btn teampswitch-primary-bg team-card-nav-button" style="color:white;">Go check it out!</router-link>
            </div>
          </div>
        </div>
        <div class="col-md-4 col-sm-6 p-1">
          <div class="card team-card teamconsistency-primary-bc">
            <img src="/assets/teams/teamconsistency/logo.png" class="card-img-top card-img-team-logo" alt="logo">
            <div class="card-body">
              <h2 class="card-title"><router-link to="/teamconsistency"><span class="teamconsistency-primary-fg">#Team</span><span class="teamconsistency-secondary-fg">Consistency</span></router-link></h2>
              <p class="card-text">
                Team Consistency. Striving for perfection.
              </p>
              <p class="card-text">We welcome all consistency, practice and Uno Más levels</p>
              <router-link to="/teamconsistency" class="btn teamconsistency-primary-bg team-card-nav-button" style="color:white;">Go check it out!</router-link>
            </div>
          </div>
        </div>
        <div class="col-md-4 col-sm-6 p-1">
          <div class="card team-card teampowerup-primary-bc">
            <img src="/assets/teams/teampowerup/logo.png" class="card-img-top card-img-team-logo card-img-rounded-logo" alt="logo">
            <div class="card-body">
              <h2 class="card-title"><router-link to="/teampowerup"><span class="teampowerup-primary-fg">Team</span><span class="teampowerup-secondary-fg"> Power Up</span></router-link></h2>
              <p class="card-text">
                Team Power Up makes kaizo levels which are focused around one or more power ups (Yoshi, shellmets, goomba shoes and buckets excluded).
              </p>
              <p class="card-text">Come and join if you have what it takes to master all the power-ups!</p>
              <router-link to="/teampowerup" class="btn teampowerup-primary-bg team-card-nav-button" style="color:white;">Go check it out!</router-link>
            </div>
          </div>
        </div>
        <div class="col-md-4 col-sm-6 p-1">
          <div class="card team-card teamspeedrun-primary-bc">
            <img src="/assets/teams/teamspeedrun/logo.png" class="card-img-top card-img-team-logo card-img-rounded-logo" alt="logo">
            <div class="card-body">
              <h2 class="card-title"><router-link to="/teamspeedrun"><span class="teamspeedrun-primary-fg">Team</span><span class="teamspeedrun-secondary-fg"> Speedrun</span></router-link></h2>
              <p class="card-text">
                Team Speedrun is a group focused on making action packed levels with little time left to spare.
              </p>
              <p class="card-text">
                From traditional-styled levels, to insane on/off shenanigans, as long as the timer is tight, this team has what you need!
              </p>
              <router-link to="/teamspeedrun" class="btn teamspeedrun-primary-bg team-card-nav-button" style="color:white;">Go check it out!</router-link>
            </div>
          </div>
        </div>
        <div class="col-md-4 col-sm-6 p-1">
          <div class="card team-card teammusic-primary-bc">
            <img src="/assets/teams/teammusic/logo.png" class="card-img-top card-img-team-logo" alt="logo">
            <div class="card-body">
              <h2 class="card-title"><router-link to="/teammusic"><span class="teammusic-primary-fg">Team</span><span class="teammusic-secondary-fg"> Music</span></router-link></h2>
              <p class="card-text">
                Team Music is an all-inclusive community interested in uniting the music level makers of the world. It doesn't matter if you make automatic levels or hard platforming levels. If you love making music in Mario Maker, this is the team for you!
              </p>
              <p class="card-text">
                Join the community, upload your levels, and let's share all the tips and setups needed to make the most banger tunes in all of Mario Maker!
              </p>
              <router-link to="/teammusic" class="btn teammusic-primary-bg team-card-nav-button" style="color:white;">Go check it out!</router-link>
            </div>
          </div>
        </div>
        <div class="col-md-4 col-sm-6 p-1">
          <div class="card team-card curatedtrolls-primary-bc">
            <img src="/assets/teams/curatedtrolls/logo.png" class="card-img-top card-img-team-logo" alt="logo">
            <div class="card-body">
              <h2 class="card-title"><router-link to="/curatedtrolls"><span class="curatedtrolls-primary-fg">Curated</span><span class="curatedtrolls-secondary-fg"> Trolls</span></router-link></h2>
              <p class="card-text">
                Curated Trolls is a collection of levels full of humorous deception, misdirection, and tricky traps.
              </p>
              <p class="card-text">
                Troll levels aim to be fun for the player, allowing them to make steady progress while also having a good laugh along the way. The levels that make the list are those widely agreed upon by the community to be broadly enjoyable by a majority of players.
              </p>
              <router-link to="/curatedtrolls" class="btn curatedtrolls-primary-bg team-card-nav-button" style="color:white;">Go check it out!</router-link>
            </div>
          </div>
        </div>
        <div class="col-md-4 col-sm-6 p-1">
          <div class="card team-card teampballoon-primary-bc">
            <img src="/assets/teams/teampballoon/logo.png" class="card-img-top card-img-team-logo" alt="logo">
            <div class="card-body">
              <h2 class="card-title"><router-link to="/teampballoon"><span class="teampballoon-primary-fg">Team</span><span class="teampballoon-secondary-fg"> Power Balloon</span></router-link></h2>
              <p class="card-text">
                Team P Balloon is all about having fun with best power up in Mario Maker.
              </p>
              <p class="card-text">
                If you are looking for exciting, creative and challenging courses that use the P Balloon then this team is for you!
              </p>
              <router-link to="/teampballoon" class="btn teampballoon-primary-bg team-card-nav-button" style="color:white;">Go check it out!</router-link>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row mt-3">
      <div class="bs-callout bs-callout-mini-teams bs-callout-title">
        <div class="bs-callout-title-box">
          <h4>These teams are currently a bit too small to be hosted, so if you like what you see go check them out and show them some love!</h4>
        </div>
      </div>
      <div class="bs-callout bs-callout-mini-teams bs-callout-content">
        <div class="col-md-3 col-sm-6 p-1">
          <div class="card team-card team-card-small">
            <img src="/assets/teams/teamghost/logo.jpg" class="card-img-top card-img-team-logo card-img-rounded-logo" alt="logo">
            <div class="card-body">
              <h4 class="card-title"><a href="https://discord.gg/sGcCAp8"><span class="teamghost-primary-fg">Team</span><span class="teamghost-secondary-fg"> Ghost</span></a></h4>
              <p class="card-text">
                Team Ghost is a Super Mario Maker 2 team which is centered around using dead (but cool-looking) enemies like boos, dry bones and fish bones.
              </p>
              <p class="card-text">
                Like most of the other teams, their main genre for level design is Kaizo and Kaizo-lite.
              </p>
              <a href="https://discord.gg/sGcCAp8" target="_blank" class="btn teamghost-primary-bg team-card-nav-button" style="color:white;">Join the discord!</a>
            </div>
          </div>
        </div>
        <div class="col-md-3 col-sm-6 p-1">
          <div class="card team-card team-card-small">
            <img src="/assets/teams/teamworldrecord/logo.png" class="card-img-top card-img-team-logo card-img-rounded-logo" alt="logo">
            <div class="card-body">
              <h4 class="card-title"><a href="https://discord.gg/RqkphtTWAs"><span class="teamworldrecord-primary-fg">Team</span><span class="teamworldrecord-secondary-fg"> World Record</span></a></h4>
              <p class="card-text">
                Team World Record is a team where you can get world records on any level in Mario Maker and get points for them. Let me repeat, you can get points from ANY LEVEL IN MARIO MAKER.
              </p>
              <p class="card-text">
                You can also play official #TWR levels, make official #TWR levels, and have fun optimizing levels!
              </p>
              <a href="https://discord.gg/RqkphtTWAs" target="_blank" class="btn teamworldrecord-primary-bg team-card-nav-button" style="color:white;">Join the discord!</a>
            </div>
          </div>
        </div>
        <div class="col-md-3 col-sm-6 p-1">
          <div class="card team-card team-card-small">
            <img src="/assets/teams/teamtwister/logo.png" class="card-img-top card-img-team-logo" alt="logo">
            <div class="card-body">
              <h4 class="card-title"><a href="https://discord.gg/TKqa8sH"><span class="teamtwister-primary-fg">#Team</span><span class="teamtwister-secondary-fg">Twister</span></a></h4>
              <p class="card-text">
                TeamTwister is a team revolving around the uses of twisters, for the good or bad of humanity.
              </p>
              <p class="card-text">
                  All types of levels are accepted as long as they use twisters and have no checkpoints. If you want to get blown away, this is the place to be!
              </p>
              <a href="https://discord.gg/TKqa8sH" target="_blank" class="btn teamtwister-primary-bg team-card-nav-button" style="color:white;">Join the discord!</a>
            </div>
          </div>
        </div>
        <div class="col-md-3 col-sm-6 p-1">
          <div class="card team-card team-card-small">
            <img src="/assets/teams/teampspeed/logo.png" class="card-img-top card-img-team-logo" alt="logo">
            <div class="card-body">
              <h4 class="card-title"><a href="https://discord.gg/q584b65"><span class="teampspeed-primary-fg">#Team</span><span class="teampspeed-secondary-fg"> P-Speed</span></a></h4>
              <p class="card-text">
                Team P-Speed is all about fast-paced platforming, kaizo, precision, whatever, as long as you don't have time to slow down.
              </p>
              <p class="card-text">
                If you're trying to see how quickly you can read this post, this is the team for you.
              </p>
              <a href="https://discord.gg/q584b65" target="_blank" class="btn teampspeed-primary-bg team-card-nav-button" style="color:white;">Join the discord!</a>
            </div>
          </div>
        </div>
        <div class="col-md-3 col-sm-6 p-1">
          <div class="card team-card team-card-small">
            <img src="/assets/teams/teambomb/logo.jpeg?v1" class="card-img-top card-img-team-logo" alt="logo">
            <div class="card-body">
              <h4 class="card-title"><a href="https://discord.gg/xFcKGYD"><span class="teambomb-primary-fg">Team</span><span class="teambomb-secondary-fg"> Bomb</span></a></h4>
              <p class="card-text">
                Team Bomb is centered all around Bob-Ombs. Kaizo and platforming stages revolving around them are all welcome here.
              </p>
              <p class="card-text">
                They support creative ways to use bombs in 3DW, SMB3, and SMB1, so don't feel like you need to make an NSMB or SMW bomb surfing level. If you enjoy bomb kaizo and platforming, this is the team for you.
              </p>
              <a href="https://discord.gg/xFcKGYD" target="_blank" class="btn teambomb-primary-bg team-card-nav-button" style="color:white;">Join the discord!</a>
            </div>
          </div>
        </div>
        <div class="col-md-3 col-sm-6 p-1">
          <div class="card team-card team-card-small">
            <img src="/assets/teams/teamnocloudabuse/logo.png?v1" class="card-img-top card-img-team-logo" alt="logo">
            <div class="card-body">
              <h4 class="card-title"><a href="https://discord.gg/H48dXPu"><span class="teamnocloudabuse-primary-fg">Team</span><span class="teamnocloudabuse-secondary-fg"> #NoCloudAbuse</span></a></h4>
              <p class="card-text">
                Team #NoCloudAbuse is a Super Mario Maker 2 team which consists of sky levels and cloudy adventures.
              </p>
              <p class="card-text">
                Similar to Yoshi Protectors this team creates ceave gaming-like contraptions to stop smb2 mario from tearing clouds out of their home.
              </p>
              <a href="https://discord.gg/H48dXPu" target="_blank" class="btn teamnocloudabuse-primary-bg team-card-nav-button" style="color:white;">Join the discord!</a>
            </div>
          </div>
        </div>
        <div class="col-md-3 col-sm-6 p-1">
          <div class="card team-card team-card-small">
            <img src="/assets/teams/teamlemmysballs/logo.png" class="card-img-top card-img-team-logo" alt="logo">
            <div class="card-body">
              <h4 class="card-title"><a href="https://discord.gg/qsYK9Tz"><span class="teamlemmysballs-primary-fg">#Team</span><span class="teamlemmysballs-secondary-fg">Lemmy'sBalls</span></a></h4>
              <p class="card-text">
                The team #TeamLemmy'sBalls is a team all about Lemmy's balls in Super Mario Maker 2.
              </p>
              <p class="card-text">
                Many people think of Roy and his shades but Lemmy and his balls need more love.
              </p>
              <a href="https://discord.gg/qsYK9Tz" target="_blank" class="btn teamlemmysballs-primary-bg team-card-nav-button" style="color:white;">Join the discord!</a>
            </div>
          </div>
        </div>
        <div class="col-md-3 col-sm-6 p-1">
          <div class="card team-card team-card-small">
            <img src="/assets/teams/teambattle/logo.jpg" class="card-img-top card-img-team-logo card-img-rounded-logo" alt="logo">
            <div class="card-body">
              <h4 class="card-title"><a href="https://discord.gg/6fxmmyu"><span class="teambattle-primary-fg">#Team</span><span class="teambattle-secondary-fg"> Battle</span></a></h4>
              <p class="card-text">
                Team Battle is a team where you can get ideas or learn how make all kinds of battle stages.
              </p>
              <p class="card-text">
                If you want to share your battle stages or play some fun and interesting levels against other people, you will not regret joining this team!
              </p>
              <a href="https://discord.gg/6fxmmyu" target="_blank" class="btn teambattle-primary-bg team-card-nav-button" style="color:white;">Join the discord!</a>
            </div>
          </div>
        </div>
        <div class="col-md-3 col-sm-6 p-1">
          <div class="card team-card team-card-small">
            <img src="/assets/teams/teamfrostysquad/logo.jpg" class="card-img-top card-img-team-logo card-img-rounded-logo" alt="logo">
            <div class="card-body">
              <h4 class="card-title"><a href="https://discord.gg/PBxzsNa"><span class="teamfrostysquad-primary-fg">Team</span><span class="teamfrostysquad-secondary-fg"> Frosty Squad</span></a></h4>
              <p class="card-text">
                The team frosty squad consists of snow and ice themed levels.
              </p>
              <p class="card-text">
                If you're cool with that this is the team for you!
              </p>
              <a href="https://discord.gg/PBxzsNa" target="_blank" class="btn teamfrostysquad-primary-bg team-card-nav-button" style="color:white;">Join the discord!</a>
            </div>
          </div>
        </div>
        <div class="col-md-3 col-sm-6 p-1">
          <div class="card team-card team-card-small">
            <img src="/assets/teams/teamego/logo.png" class="card-img-top card-img-team-logo" alt="logo">
            <div class="card-body">
              <h4 class="card-title"><a href="https://discord.gg/4f3GXjK"><span class="teamego-primary-fg">#Team</span><span class="teamego-secondary-fg">Ego</span></a></h4>
              <p class="card-text">
                TeamEgo is trying to create a home for everybody who likes fun levels. Puzzle, troll, Kaizo, you name it.
              </p>
              <p class="card-text">
                If you like all kinds of levels, as long as they're creative and fun to play, this is the place for you.
              </p>
              <a href="https://discord.gg/4f3GXjK" target="_blank" class="btn teamego-primary-bg team-card-nav-button" style="color:white;">Join the discord!</a>
            </div>
          </div>
        </div>
        <div class="col-md-3 col-sm-6 p-1">
          <div class="card team-card team-card-small">
            <img src="/assets/teams/teamjuggle/logo.png" class="card-img-top card-img-team-logo card-img-rounded-logo" alt="logo">
            <div class="card-body">
              <h4 class="card-title"><a href="https://discord.gg/KsSVezu"><span class="teamjuggle-primary-fg">Team</span><span class="teamjuggle-secondary-fg"> Juggle</span></a></h4>
              <p class="card-text">
                Team Juggle is a Super Mario Maker 2 team that consists of levels involving item and shell juggling.
              </p>
              <p class="card-text">
                Whether you like simple juggling levels or very complex ones, all levels are welcome here.
              </p>
              <a href="https://discord.gg/KsSVezu" target="_blank" class="btn teamjuggle-primary-bg team-card-nav-button" style="color:white;">Join the discord!</a>
            </div>
          </div>
        </div>
        <div class="col-md-3 col-sm-6 p-1">
          <div class="card team-card team-card-small">
            <img src="/assets/teams/teamyoshi/logo.png" class="card-img-top card-img-team-logo card-img-rounded-logo" alt="logo">
            <div class="card-body">
              <h4 class="card-title"><a href="https://discord.gg/b3qsRtT"><span class="teamyoshi-primary-fg">Team</span><span class="teamyoshi-secondary-fg"> Yoshi</span></a></h4>
              <p class="card-text">
                Team Yoshi is the best place to find everything revolving around our favorite dinosaur companion, no matter if it's kaizo, puzzle or platforming levels.
              </p>
              <p class="card-text">
                No matter if you want to save or kill all yoshis, this team is for you.
              </p>
              <a href="https://discord.gg/b3qsRtT" target="_blank" class="btn teamyoshi-primary-bg team-card-nav-button" style="color:white;">Join the discord!</a>
            </div>
          </div>
        </div>
        <div class="col-md-3 col-sm-6 p-1">
          <div class="card team-card team-card-small">
            <img src="/assets/teams/teamteam/logo.png" class="card-img-top card-img-team-logo card-img-rounded-logo" alt="logo">
            <div class="card-body">
              <h4 class="card-title"><a href="https://discord.gg/afKFcGC"><span class="teamteam-primary-fg">Team</span><span class="teamteam-secondary-fg"> Team</span></a></h4>
              <p class="card-text">
                Team Team's goal is to have a team where everyone feels that they have a variety of levels for them. It doesn't matter if you like Precision, Kaizo, Powerups, or anything else, they'll be sure to have it.
              </p>
              <p class="card-text">
                If you want to try out every single type of level that mario offers, this is the place to be.
              </p>
              <a href="https://discord.gg/afKFcGC" target="_blank" class="btn teamteam-primary-bg team-card-nav-button" style="color:white;">Join the discord!</a>
            </div>
          </div>
        </div>
        <div class="col-md-3 col-sm-6 p-1">
          <div class="card team-card team-card-small">
            <img src="/assets/teams/teamwalljamp/logo.png" class="card-img-top card-img-team-logo card-img-rounded-logo" alt="logo">
            <div class="card-body">
              <h4 class="card-title"><a href="https://discord.gg/gSum9UCPBH"><span class="teamwalljamp-primary-fg">Team</span><span class="teamwalljamp-secondary-fg">WallJamp</span></a></h4>
              <p class="card-text">
                Team Wall Jamp is all about the best move in the modern styles: wall jumps!
              </p>
              <p class="card-text">
                This team accepts all kinds of levels from traditional to kaizo, precision to speedrun, you name it! If you like sliding down walls as well then this is where you should be headed.
              </p>
              <a href="https://discord.gg/gSum9UCPBH" target="_blank" class="btn teamwalljamp-primary-bg team-card-nav-button" style="color:white;">Join the discord!</a>
            </div>
          </div>
        </div>
        <div class="col-md-3 col-sm-6 p-1">
          <div class="card team-card team-card-small">
            <img src="/assets/teams/teamglitches/logo.png" class="card-img-top card-img-team-logo card-img-rounded-logo" alt="logo">
            <div class="card-body">
              <h4 class="card-title"><a href="https://discord.gg/2MVW58Bxt3"><span class="teamglitches-primary-fg">Team</span><span class="teamglitches-secondary-fg">Glitches</span></a></h4>
              <p class="card-text">
                TeamGlitches is the place where you can share all glitches you find!
              </p>
              <p class="card-text">
                If you love to find glitches and make Uno Mas levels, this is where you need to be! Have fun sharing your fun glitch levels and videos!
              </p>
              <a href="https://discord.gg/2MVW58Bxt3" target="_blank" class="btn teamglitches-primary-bg team-card-nav-button" style="color:white;">Join the discord!</a>
            </div>
          </div>
        </div>
        <div class="col-md-3 col-sm-6 p-1">
          <div class="card team-card team-card-small">
            <img src="/assets/teams/teamhang10/logo.png" class="card-img-top card-img-team-logo card-img-rounded-logo" alt="logo">
            <div class="card-body">
              <h4 class="card-title"><a href="https://discord.gg/qNQCyCCgCs"><span class="teamhang10-primary-fg">Team</span><span class="teamhang10-secondary-fg"> Hang 10</span></a></h4>
              <p class="card-text">
                Team Hang 10 is an Item based Kaizo team focusing on levels built exclusively around surf tricks.
              </p>
              <p class="card-text">
                If you enjoy fun, challenging levels with a great flow, join our discord and come ride the wave!
              </p>
              <a href="https://discord.gg/qNQCyCCgCs" target="_blank" class="btn teamhang10-primary-bg team-card-nav-button" style="color:white;">Join the discord!</a>
            </div>
          </div>
        </div>
        <div class="col-md-3 col-sm-6 p-1">
          <div class="card team-card team-card-small">
            <img src="/assets/teams/teamupsidedown/logo.png" class="card-img-top card-img-team-logo card-img-rounded-logo" alt="logo">
            <div class="card-body">
              <h4 class="card-title"><a href="https://discord.gg/GHeYUfHTv4"><span class="teamupsidedown-primary-fg">Team </span><span class="teamupsidedown-secondary-fg"> Upsidedown</span></a></h4>
              <p class="card-text">
                Team Upsidedown is all the fun you can have in Mario Maker, but from a different point of view. Upsidedown!
              </p>
              <p class="card-text">
                #ꓕEⱯW ꓵbƧIDEDOMИ
              </p>
              <a href="https://discord.gg/GHeYUfHTv4" target="_blank" class="btn teamupsidedown-primary-bg team-card-nav-button" style="color:white;">Join the discord!</a>
            </div>
          </div>
        </div>
        <div class="col-md-3 col-sm-6 p-1">
          <div class="card team-card team-card-small">
            <img src="/assets/teams/teamtimeattack/logo.png" class="card-img-top card-img-team-logo card-img-rounded-logo" alt="logo">
            <div class="card-body">
              <h4 class="card-title"><a href="https://discord.gg/amjMhWPB8N"><span class="teamtimeattack-primary-fg">Team </span><span class="teamtimeattack-secondary-fg"> Time Attack</span></a></h4>
              <p class="card-text">
                Team Time-Attack is a Team centered around Levels with extremely tight Timers.
              </p>
              <p class="card-text">
                From simple hold-right optimisations to super tight Wall-Jump mazes, this Team is open to any kind of Challenge. If you enjoy beating Levels where every kind of Time-Save matters, this is the place to be.
              </p>
              <a href="https://discord.gg/amjMhWPB8N" target="_blank" class="btn teamtimeattack-secondary-bg team-card-nav-button" style="color:white;">Join the discord!</a>
            </div>
          </div>
        </div>
        <div class="col-md-3 col-sm-6 p-1">
          <div class="card team-card team-card-small">
            <img src="/assets/teams/teamfantastik/logo.png" class="card-img-top card-img-team-logo card-img-rounded-logo" alt="logo">
            <div class="card-body">
              <h4 class="card-title"><a href="https://discord.gg/xdnTAuCMcr"><span class="teamfantastik-primary-fg">Team </span><span class="teamfantastik-secondary-fg"> Fantastik</span></a></h4>
              <p class="card-text">
                TeamFantastik is a team filled with creative makers that love making fun levels with a mixture of shell tricks and fun platforming in a "RomHack" style. Our team welcomes anyone who loves to build or play levels that are well-made, intuitive, and fun to play.
              </p>
              <p class="card-text">
                Come join our discord and meet some FANTASTIK people!
              </p>
              <a href="https://discord.gg/xdnTAuCMcr" target="_blank" class="btn teamfantastik-primary-bg team-card-nav-button" style="color:white;">Join the discord!</a>
            </div>
          </div>
        </div>
        <div class="col-md-3 col-sm-6 p-1">
          <div class="card team-card team-card-small">
            <img src="/assets/teams/teamzelda/logo.png" class="card-img-top card-img-team-logo card-img-rounded-logo" alt="logo">
            <div class="card-body">
              <h4 class="card-title"><a href="https://discord.gg/KSVQed24dJ"><span class="teamzelda-primary-fg">Team </span><span class="teamzelda-secondary-fg"> Zelda</span></a></h4>
              <p class="card-text">
                Team Zelda is a team for Link players wanting to explore the depths of dungeons, enjoying hardcore Link kaizo levels or even like to speedrun with a sword at hand.
              </p>
              <p class="card-text">
                All of these are welcome in Team Zelda!
              </p>
              <a href="https://discord.gg/KSVQed24dJ" target="_blank" class="btn teamzelda-primary-bg team-card-nav-button" style="color:white;">Join the discord!</a>
            </div>
          </div>
        </div>
        <div class="col-md-3 col-sm-6 p-1">
          <div class="card team-card team-card-small">
            <img src="/assets/teams/teammuncher/logo.png" class="card-img-top card-img-team-logo card-img-rounded-logo" alt="logo">
            <div class="card-body">
              <h4 class="card-title"><a href="https://discord.gg/xXJenyttTH"><span class="teammuncher-primary-fg">Team </span><span class="teammuncher-secondary-fg"> muncher</span></a></h4>
              <p class="card-text">
                Enjoy kaizo, platforming, precision, and more other fun types of SMM2 gaming with Munchers!
              </p>
              <a href="https://discord.gg/xXJenyttTH" target="_blank" class="btn teammuncher-primary-bg team-card-nav-button" style="color:white;">Join the discord!</a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'Teams',
    components: {
    },
    data() {
      return {
      };
    },
    mounted(){
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
